/* Ciepłopas kosz: pasek przewijania, kosz z piłką w hero, odsłanianie sekcji */
(function () {
  if (window.koszFx) return;
  window.koszFx = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var bar = document.createElement('div');
    bar.className = 'fx-progress';
    document.body.appendChild(bar);
    var tick = function () {
      var h = document.documentElement;
      bar.style.setProperty('--p', Math.min(1, h.scrollTop / ((h.scrollHeight - h.clientHeight) || 1)));
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();

    var media = document.querySelector('.dww-hero__media');
    if (media && !reduce) {
      media.insertAdjacentHTML('beforeend',
        '<div class="fx-hoop" aria-hidden="true"><svg viewBox="0 0 86 86">' +
        '<rect x="8" y="2" width="70" height="46" rx="6" fill="#fff" stroke="#111" stroke-width="3"/>' +
        '<rect x="29" y="16" width="28" height="20" fill="none" stroke="#d9480f" stroke-width="3"/>' +
        '<path class="fx-net" d="M25 50L31 72M33 51L36 73M43 52V74M53 51L50 73M61 50L55 72M27 58H59M30 66H56" stroke="#fff" stroke-width="2" opacity=".9"/>' +
        '<ellipse cx="43" cy="50" rx="18" ry="4" fill="none" stroke="#ff6a1a" stroke-width="4"/>' +
        '</svg><span class="fx-ball-x"><span class="fx-ball"></span></span></div>');
    }

    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        el.classList.add('is-in');
        countUp(el);
        var delay = parseFloat(el.style.getPropertyValue('--d')) || 0;
        setTimeout(function () {
          el.classList.remove('fx-up', 'is-in');
          el.style.removeProperty('--d');
        }, 1200 + delay * 1000);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    // [selektor, opóźnienie między kolejnymi elementami w sekundach]
    [
      ['.dww h2', 0],
      ['.dww .dww__lead', 0],
      ['.dww-card', 0.12],
      ['.dww-kit li', 0.1],
      ['.dww-table tbody tr', 0.1],
      ['.dww-fact', 0.12],
      ['.dww-faq details', 0.06]
    ].forEach(function (g) {
      document.querySelectorAll(g[0]).forEach(function (el) {
        if (el.closest('.dww-hero') || el.classList.contains('fx-up')) return;
        var i = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.setProperty('--d', (i * g[1]).toFixed(2) + 's');
        el.classList.add('fx-up');
        io.observe(el);
      });
    });
  }

  // Liczba w kafelku dostawy (np. "14 dni") odlicza od zera
  function countUp(el) {
    var s = el.matches('.dww-fact') && el.querySelector('strong');
    var m = s && s.textContent.match(/^(\d+)(\s.*)$/);
    if (!m || +m[1] < 2) return;
    var end = +m[1], rest = m[2], t0 = performance.now();
    (function step(t) {
      var k = Math.min(1, (t - t0) / 900);
      s.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))) + rest;
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
